module.exports = __webpack_public_path__ + "img/ic-star.cb1e50bd.svg";